import CloseModal from './CloseModal';

export {
  CloseModal
};
